import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.community.notice');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-community-notice',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.community.notice/view.scss */
@keyframes noticeSlideUp {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
}
@keyframes noticeSlideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.notice-slide-up {
  animation: noticeSlideUp 0.3s ease-in-out forwards;
}

.notice-slide-in {
  animation: noticeSlideIn 0.3s ease-in-out forwards;
}`],
})
export class PortalCommunityNoticeComponent implements OnInit, OnDestroy {

    public list: any[] = [];
    public item: any = null;
    public index: number = 0;
    public animating: boolean = false;

    private timer: any = null;
    private innerTimer: any = null;

    constructor(@Inject( Service) public service: Service) {}

    async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    async load() {
        const res = await wiz.call('search', {});

        if (res?.code === 200) {
            this.list = res.data.list || [];
            this.index = 0;

            if (this.list.length > 0) {
                this.item = this.list[0];

                if (this.list.length > 1) {
                    this.startRotate();
                }
            }
        }

        await this.service.render();
    }

    startRotate() {
        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(async () => {
            this.animating = true;
            await this.service.render();

            this.innerTimer = setTimeout(async () => {
                this.index = (this.index + 1) % this.list.length;
                this.item = this.list[this.index];
                this.animating = false;
                await this.service.render();
                this.startRotate();
            }, 300);
        }, 3000);
    }

    ngOnDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        if (this.innerTimer) {
            clearTimeout(this.innerTimer);
            this.innerTimer = null;
        }
    }
}

export default PortalCommunityNoticeComponent;